var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/next_video.ed27381c.png","uri@3x": __webpack_public_path__ + "static/media/next_video.6c5fa12e.png","uri@2x": __webpack_public_path__ + "static/media/next_video.93159092.png",
    width: 40,
    height: 25
});